
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NodeEventData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CoreNodeEventModelEntity"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntityEventData"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodeType"},"arguments":[],"directives":[]}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("../entities/EntityEventData.fragment.graphql").definitions));


    module.exports = doc
  
